import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { DrawerSectionTitle } from './DrawerSectionTitle';

interface DrawerSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export const DrawerSection = ({ title, children, className }: DrawerSectionProps) => (
  <div className={twMerge('h-fit text-sm', className)} title={title}>
    <DrawerSectionTitle>{title}</DrawerSectionTitle>
    <div data-testid={'block-placement'} className="flex flex-col gap-3">
      {children}
    </div>
  </div>
);
